module.exports = __webpack_public_path__ + "static/media/onboarding_wix.39a07869.svg";